import load from "./load";
// import lottieAnimation from "./lottie";

load();
// lottieAnimation();
